module.exports = __webpack_public_path__ + "static/media/food-img.c26c47e9.jpeg";